module.exports = __webpack_public_path__ + "static/media/0101.4c8cfce9.png";